import type { MouseEvent } from 'react';

const INNER_CONTROL = 'a, button, input, select, textarea, label, [role="button"]';

export const selectOnCardClick =
  (onSelect: () => void) =>
  (event: MouseEvent<HTMLElement>): void => {
    const control = event.target instanceof Element ? event.target.closest(INNER_CONTROL) : null;

    if (control && control !== event.currentTarget && event.currentTarget.contains(control)) {
      return;
    }

    onSelect();
  };
